<template>
  <v-container fluid>
    <a-input-group compact class="mb-2">
      <a-date-picker v-model="queryForm.date" :locale="locale" placeholder="日期" format="YYYY-MM-DD"
        valueFormat="YYYY-MM-DD" size="large" :allowClear="false" style="width:10%" @change="init" />
      <a-select v-model="queryForm.names" :options="names" mode="multiple" placeholder="请选择" size="large"
        style="width:70%;">
      </a-select>
      <div style="width:20%;">
        <a-button type="primary" size="large" @click="getdata()">
          查询
        </a-button>
        <a-button class="ml-2" size="large" @click="getdata('download')">
          导出EXECL
        </a-button>
      </div>
    </a-input-group>
    <a-collapse :bordered="false">
      <a-collapse-panel key="1" header="调度建议">
        <a-textarea v-if="editing" v-model="edit_suggestion" placeholder="调度建议"
          :auto-size="{ minRows: 3, maxRows: 5 }" />
        <div v-else v-html="suggestion"></div>
        <a-space v-if="editing">
          <a href="javascript:;" class="success--text" @click="saveSuggestion">保存</a>
          <a href="javascript:;" class="error--text" @click="cancelSuggestion">取消</a>
        </a-space>
        <template #extra><v-icon @click="editSuggestion">mdi-plus</v-icon></template>
      </a-collapse-panel>
    </a-collapse>
    <a-tabs v-model="activeKey" @change="getdata()">
      <a-tab-pane key="1" tab="运行时间统计"></a-tab-pane>
      <a-tab-pane key="2" tab="运行时间明细"></a-tab-pane>
    </a-tabs>
    <CalcStatistics v-if="activeKey === '1'" ref="calcstatistics" />
    <CalcDetail v-if="activeKey === '2'" ref="calcdetail" />
  </v-container>
</template>

<script>
import _ from "underscore";
import { message } from "ant-design-vue";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
import CalcStatistics from './calcstatistics.vue'
import CalcDetail from './calcdetail.vue'
export default {
  name: "OrderCalc",
  data() {
    return {
      locale,
      activeKey: "1",
      queryForm: {
        date: this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
        names: ["郑州", "开封", "商丘", "南阳", "信阳", "驻马店"],
      },
      data: [],
      columns: [],
      names: [],
      dispatch_suggestion: '',
      editing: false,
      edit_suggestion: '',
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    suggestion() {
      return (this.dispatch_suggestion || "").split('\n').map(n => `<p>${n}</p>`).join('');
    },
  },
  components: {
    CalcStatistics,
    CalcDetail,
  },
  watch: {

  },
  mounted() {
    this.queryForm = {
      date: this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
      names: ["郑州", "开封", "商丘", "南阳", "信阳", "驻马店"],
    };
    this.init();
  },
  methods: {
    getdata(action) {
      console.log('getdata', action, this.activeKey);
      this.$nextTick(() => {
        if (this.activeKey === '1') {
          this.$refs.calcstatistics.getdata({ ...this.queryForm, action });
        }
        else if (this.activeKey === '2') {
          this.$refs.calcdetail.getdata({ ...this.queryForm, action });
        }
      });
    },
    init() {
      this.$api.doAPI("/waybill/calcinit", this.queryForm).then((res) => {
        if (res.code === 0) {
          this.names = res.data.names;
          this.queryForm.names = res.data.default_names;
          this.dispatch_suggestion = res.data.dispatch_suggestion;
          this.getdata();
        }
      }).catch((err) => {
        console.error(err);
      });
    },
    editSuggestion() {
      this.editing = true;
      this.edit_suggestion = this.dispatch_suggestion;
    },
    cancelSuggestion() {
      this.editing = false;
    },
    saveSuggestion() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/waybill/savesuggestion", { date: this.queryForm.date, content: this.edit_suggestion }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          message.success('保存成功');
          this.dispatch_suggestion = this.edit_suggestion;
          this.editing = false;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
// /deep/ .ant-table-header-column {
//   font-size: 12px;
// }

/deep/ .ant-table-row-cell-break-word {
  padding: 0 !important;
}

// /deep/ .ant-table-small>.ant-table-content>.ant-table-scroll>.ant-table-body>table>.ant-table-thead>tr>th {
//   padding: 0;
// }

// /deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
//   padding-bottom: 4px;
// }

// /deep/ .ant-table-thead {
//   font-size: 14px !important;
// }

/deep/ .ant-collapse>.ant-collapse-item>.ant-collapse-header {
  padding: 6px 8px;
  padding-left: 30px;
}

/deep/ p {
  margin: 0;
  padding: 0;
}
</style>
